import React, { createContext, useEffect, useState } from "react";
import BatteryImage from "../../assets/battery.png";
import Inverter from "../../assets/Vector (1).png";
import { FindDealerApi, ConnectDealerApi } from "../../api/Api";
import { useLocation } from "react-router-dom";
export const ProductPageContext = createContext({});
export const ProductPageContextProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [showEnquireModal, setShowEnquireModal] = useState(false);

  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [comments, setComments] = useState("");
  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [dealerData, setDealerData] = useState([]);
  const [showDealerData, setshowDealerData] = useState(false);
  const [topChoice, setTopChoice] = useState({});
  const [comboShow, setComboShow] = useState(false);
  const location = useLocation();
  const productData = location.state.productData;
  const domain = location.state.domain;
  const flowId = productData.flowId;
  const suggestedInverter = productData?.recommendedDevices.inverters[0].name;
  const warningMessage = location?.state?.warningData;
  useEffect(() => {
    const topChoices = {
      battery: {
        name: productData?.recommendedDevices.batteries.model,
        capacity: productData?.recommendedDevices.batteries.capacity,
        warranty: productData?.recommendedDevices.batteries.warranty,
        url: productData?.recommendedDevices.batteries.url,
        image: productData?.recommendedDevices.batteries.image,
      },
      inverter: {
        name: productData?.recommendedDevices.inverters[0].name,
        capacity:
          productData?.recommendedDevices.inverters[0].powerInVoltAmperes,
        warranty: productData?.recommendedDevices.inverters[0].warranty,
        url: productData?.recommendedDevices.inverters[0].url,
        image: productData?.recommendedDevices.inverters[0].image,
        type: productData?.recommendedDevices.inverters[0].type,
        solarModel: productData?.recommendedDevices.inverters[0].solarModel,
        mobileConnectivity:
          productData?.recommendedDevices.inverters[0].mobileConnectivity,
      },
      comboInverter: {
        name: productData?.recommendedDevices.comboInverters[0]?.name,
        image: productData?.recommendedDevices.comboInverters[0]?.image,
        url: productData?.recommendedDevices.comboInverters[0]?.url,
        type: productData?.recommendedDevices.comboInverters[0]?.type,
        solarModel:
          productData?.recommendedDevices.comboInverters[0]?.solarModel,
        mobileConnectivity:
          productData?.recommendedDevices.comboInverters[0]?.mobileConnectivity,
        power: productData?.recommendedDevices.comboInverters[0]?.power,
      },
    };
    setTopChoice(topChoices);
    if (productData?.recommendedDevices?.comboInverters?.length > 0) {
      setComboShow(true);
    }
  }, [productData]);

  const capitalizeWords = (input) => {
    if (!input) {
      return "";
    }
    return input.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const popupUserDetails = {
    name,
    setName,
    phone,
    setPhone,
    email,
    setEmail,
    comments,
    setComments,
    selectedState,
    setSelectedState,
    selectedCity,
    setSelectedCity,
  };

  const userDetailsToSend = {
    flowId: flowId,
    name: name,
    email: email,
    phone: phone,
    state: selectedState,
    city: selectedCity,
    comment: comments,
    categories: "Inverter",
    product: suggestedInverter,
  };

  const handleInputChange = (value) => {
    setSearchQuery(value);
  };
  // on submit -find dealer
  const handleSearch = () => {
    FindDealer(searchQuery);
    setshowDealerData(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setDealerData([]);
    setshowDealerData(false);
    setSearchQuery("");
  };

  // recommended product API
  const FindDealer = async (searchQuery) => {
    setIsLoading(true);
    try {
      const response = await FindDealerApi(searchQuery);
      if (response?.status === 200) {
        setPopupMessage("");
        setDealerData(response?.data?.data);
      }
      setIsLoading(false);
    } catch (error) {
      if (error.response?.status === 400) {
        setPopupMessage(error.response.data.message);
      }
      setDealerData([]);
      setIsLoading(false);
    }
  };

  const ConnectDealer = async (UserDetails) => {
    try {
      const response = await ConnectDealerApi(UserDetails);
      console.log("ConnectDealer response", response?.data?.message);
      if (response?.status === 200) {
        setShowEnquireModal(false);
        setSuccessPopup(true);
        setPopupMessage(response?.data?.message);
      }
    } catch (error) {
      setShowEnquireModal(false);
      setErrorPopup(true);
      setPopupMessage(error?.response?.data?.message || "SomeThing Went Wrong");
      // console.log("error", error?.response?.data?.message);
    }
    setName("");
    setPhone("");
    setEmail("");
    setComments("");
    setSelectedState("");
    setSelectedCity("");
  };

  const providerValue = {
    showModal,
    setShowModal,
    dealerData,
    handleInputChange,
    handleSearch,
    showEnquireModal,
    setShowEnquireModal,
    popupUserDetails,
    ConnectDealer,
    userDetailsToSend,
    isLoading,
    handleCloseModal,
    showDealerData,
    productData,
    topChoice,
    successPopup,
    setSuccessPopup,
    errorPopup,
    setErrorPopup,
    popupMessage,
    domain,
    capitalizeWords,
    warningMessage,
    comboShow,
  };
  return (
    <ProductPageContext.Provider value={providerValue}>
      {children}
    </ProductPageContext.Provider>
  );
};
